// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// stylesheets
import './assets/css/pure-min.css'
import './assets/css/grids-responsive-min.css'
import './assets/css/jquery-ui.css'
import './assets/css/quill.snow.css'
// import './assets/css/fontawesome-all.min.css'
// import './assets/css/jquery.tagit.css'
import './assets/css/jquery.contextMenu.min.css'

// scripts
// import $ from "jquery";
// // import 'jquery-ui-dist/jquery-ui.js';
// import './assets/js/jquery-ui.js'
// import './assets/js/jquery.transit.min.js'
// import './assets/js/ajaxq.js'
// // import './assets/js/lazyload.es2015.js'
// import './assets/js/image-compressor.min.js'
// // import './assets/js/tag-it.min.js'
// import './assets/js/jquery.contextMenu.min.js'
// import './assets/js/es6-promise.auto.min.js'

import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueFire from 'vuefire'
import App from './App'
import router from './router'
import InstantSearch from 'vue-instantsearch'
import VueNoty from 'vuejs-noty'
import VueLazyload from 'vue-lazyload'
var infiniteScroll =  require('vue-infinite-scroll');
var Promise = require('es6-promise').Promise;

Vue.config.productionTip = false

Vue.use(VueFire)
Vue.use(InstantSearch)
Vue.use(infiniteScroll)
Vue.use(VueLazyload)
Vue.use(VueAnalytics, {
  id: 'UA-118872781-1',
  router
})

Vue.use(VueNoty, {
  timeout: 2000,
  progressBar: false,
  layout: 'topRight',
  theme: 'metroui',
  animation: {
	open: 'animated fadeIn', // Animate.css class names
	close: 'animated fadeOut' // Animate.css class names
  }
})

var parts = location.hostname.split('.');
var subdomain = parts.shift();
console.log(subdomain);

var isPress = subdomain === 'press' ? true : false
if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
  // isPress = true // override for local testing  
}

Vue.prototype.$eventHub = new Vue() // Global event bus
Vue.prototype.$globals = new Vue()
Vue.prototype.$globals.siteHasLoaded = false
Vue.prototype.$globals.userRole = 'user'
Vue.prototype.$globals.userCanEditGrapes = false
Vue.prototype.$globals.userCanEditGrapevines = false
Vue.prototype.$globals.isPress = isPress
Vue.prototype.$globals.grapesDatabase = isPress ? 'proGrapes' : 'grapes'
Vue.prototype.$globals.grapevinesDatabase = isPress ? 'proGrapevines' : 'grapevines'
Vue.prototype.$globals.grapeRatingsDatabase = isPress ? 'proGrapeRatings' : 'grapeRatings'
Vue.prototype.$globals.grapePath = isPress ? 'https://press.atgrapevine.com/view-grape/' : 'https://atgrapevine.com/view-grape/'
Vue.prototype.$globals.grapevinePath = isPress ? 'https://press.atgrapevine.com/grapevine/' : 'https://atgrapevine.com/grapevine/'
Vue.prototype.$globals.authorPath = isPress ? 'https://press.atgrapevine.com/author/' : 'https://atgrapevine.com/author/'
Vue.prototype.$globals.bookPath = 'https://atgrapevine.com/book/'
Vue.prototype.$globals.publicationPath = 'https://press.atgrapevine.com/publication/'


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js